import { createSelector } from 'reselect'
import createCachedSelector from 're-reselect'
import { constructSearchQueryObject } from 'util/search'
import { filterRegex } from 'util/search/filter'
import { emptyArr } from 'util/arrays'
import { selectTicketSearchOperatorValueMap } from './base'

export const selectTicketSearchQueryObjectByQueryString = createCachedSelector(
  (_state, queryString) => queryString,
  selectTicketSearchOperatorValueMap,
  (queryString, operatorValueMap) => {
    return constructSearchQueryObject(queryString, operatorValueMap)
  }
)((_state, queryString) => queryString || 'unknown')

export function selectCurrentSubmittedTicketSearchQueryString(state) {
  const { submittedSearchQueryString } = state.search
  if (submittedSearchQueryString || submittedSearchQueryString === '') {
    return submittedSearchQueryString
  }
  return null
}

export const selectCurrentSubmittedTicketSearchQueryObject = createSelector(
  selectCurrentSubmittedTicketSearchQueryString,
  selectTicketSearchOperatorValueMap,
  (queryString, operatorValueMap) => {
    return constructSearchQueryObject(queryString, operatorValueMap)
  }
)

export const selectCurrentSubmittedTicketSearchFilterMatches = createSelector(
  selectCurrentSubmittedTicketSearchQueryString,
  submittedSearchQueryString => {
    if (!submittedSearchQueryString) return []
    return (
      Array.from(
        new Set(submittedSearchQueryString.match(new RegExp(filterRegex, 'g')))
      ) || []
    )
  }
)

export const selectSearchMailboxes = state =>
  state.search.searchMailboxes || emptyArr
export const selectIsReloadingSubmittedSearchQuery = state =>
  state.search.isReloadingSubmittedSearchQuery

export const selectSearchEditorState = state => state.search.editorState
export const selectSearchEditor = state => state.search.editor
